import React from 'react';
import { NavigationTabs } from '@ui';
import { NavigationTabsItem } from '@app/components/ui/navigation-tabs/navigation-tabs';
import { navigationRoutes } from '@app/utils/navigation-routes';
import useTranslation from '@app/hooks/use-translation';

const UsersNavigationBlock = () => {
  const { t } = useTranslation('pages.usersPage');

  const navigationItemsList: NavigationTabsItem[] = [
    {
      link: '/' + navigationRoutes.users,
      icon: 'UserIcon',
      label: t('navigation_bar.users'),
      index: 'users',
    },
    {
      link: navigationRoutes.users_groups,
      icon: 'UserIcon',
      label: t('navigation_bar.users_groups'),
      index: 'usersGroups',
    },
    {
      link: navigationRoutes.qm_users,
      icon: 'UserIcon',
      label: t('navigation_bar.qm_users'),
      index: 'qmUsers',
    },
    {
      link: navigationRoutes.users_synchronization_AD,
      icon: 'UserIcon',
      label: t('navigation_bar.users_synchronization'),
      index: 'users_synchronization_AD',
    },
  ];
  return <NavigationTabs items={navigationItemsList} />;
};

export default UsersNavigationBlock;
